import { render, staticRenderFns } from "./PtoCompressed.vue?vue&type=template&id=1d8ce584&scoped=true"
import script from "./PtoCompressed.vue?vue&type=script&lang=js"
export * from "./PtoCompressed.vue?vue&type=script&lang=js"
import style0 from "./PtoCompressed.vue?vue&type=style&index=0&id=1d8ce584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8ce584",
  null
  
)

export default component.exports